import { Switch, Route } from 'react-router-dom';

// AUTH
import authenticated from 'containers/Authenticated';

// CONSTANTS
import { FLEET_PLANS } from 'constants/plans';

// COMPONENTS
import AgreementSettings from 'views/FleetSettings/AgreementSettings';
import Charges from 'views/FleetSettings/Charges';
import Payment from 'views/FleetSettings/Payment';
import UserManagement from 'views/FleetSettings/UserManagement';
import Vehicles from 'views/FleetSettings/Vehicles';
import Telematics from 'views/FleetSettings/Telematics';
import Geofencing from 'views/FleetSettings/Geofencing';
import Departments from 'views/FleetSettings/Departments';

// HOOKS
import usePlans from 'hooks/usePlans';

// FLEET-2507: raise authenticated(Payment) outside of routes to prevent infinite fetching of dealership settings after hierarchy changes
const authenticatedPayment = authenticated(Payment);

const FleetSettingsRoutes = () => {
  const { isDealershipPlanEqualOrAbove } = usePlans();

  return (
    <Switch>
      <Route path={'/fleet/settings'} component={authenticated(AgreementSettings)} exact />
      <Route path={`/fleet/settings/users`} component={authenticated(UserManagement)} exact />
      <Route path={`/fleet/settings/charges`} component={authenticated(Charges)} exact />
      <Route path={`/fleet/settings/payment`} component={authenticatedPayment} exact />
      <Route path={`/fleet/settings/departments`} component={authenticated(Departments)} exact />
      <Route path={`/fleet/settings/vehicles`} component={authenticated(Vehicles)} exact />
      <Route path={`/fleet/settings/telematics`} component={authenticated(Telematics)} exact />
      {isDealershipPlanEqualOrAbove(FLEET_PLANS.pro) && (
        <Route path={`/fleet/settings/geofencing`} component={authenticated(Geofencing)} exact />
      )}
    </Switch>
  );
};

export default FleetSettingsRoutes;
